import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import { Toaster } from "react-hot-toast";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import CV from "./pages/CV";
import Articles from "./pages/Articles";
import NotFound from "./pages/NotFound";
import Upload from "./pages/Upload";

const App = () => {
  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/upload" element={<Upload />} />
          </Routes>
        </Router>
        <Toaster />
      </div>
    </ErrorBoundary>
  );
};

export default App;
